import axios from "axios";
import { message } from "antd";

const apiUrl = process.env.REACT_APP_API_URL;

export const get_entities = async (token, company_id, entity) => {
	try {
		const body = {
			token,
			company_id,
			entity,
		};
		
		const res = await axios.post(`${apiUrl}/get_entities`, body);
		if (res.status == 200) return res.data;		
		message.error(res.data);
	} catch (err) {
		message.error(err.response.data);
	}
};

export const get_company_by_nit_for_entity = async (token, company_nit, type_tid, isCreatingCompany = false, is_associated_company = false) => {
	try {
		const body = {
			token,
			company_nit,
			type_tid,
			isCreatingCompany,
			is_associated_company,
		};

		const res = await axios.post(`${apiUrl}/get_company_by_nit_for_entity`, body);
		if (res.status == 200) return res.data;		
		message.error(res.data);
	} catch (err) {
		message.error(err.response.data);
	}
};

export const edit_entity = async (token, edit_value, data, entity) => {
	try {
		const body = {
			token,
			edit_value,
			data,
			entity,
		};

		const res = await axios.post(`${apiUrl}/edit_entity`, body);
		if (res.status == 200 || res.status == 201) return res.data;
		message.error(res.data);
	} catch (err) {
		message.error(err.response.data);
	}
};
